import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { TranslationCalc } from "../components/TranslationCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.translate_tool_name()}
        toolPath="/protein-translation"
      />
      <SciHeader title={m.translate_h1()} intro={m.translate_intro()} />

      <TranslationCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.translate_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.translate_ex1(), m.translate_ex2(), m.translate_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.translate_faq_q1(), a: m.translate_faq_a1() },
          { q: m.translate_faq_q2(), a: m.translate_faq_a2() },
          { q: m.translate_faq_q3(), a: m.translate_faq_a3() },
          { q: m.translate_faq_q4(), a: m.translate_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
